import { Mail, Clock, Globe } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";
import PageHero from "@/components/PageHero";
import { ContactForm } from "@/components/LeadForms";
import { Reveal } from "@/components/Reveal";

export default function Contact() {
  useSEO(
    "Contact Synergy Outsourcing | Let's Talk About Your Next Hire",
    "Start a conversation with Synergy Outsourcing about building a dedicated managed team for your business. We typically respond within one business day."
  );
  return (
    <>
      <PageHero
        eyebrow="Contact"
        lines={["Let's talk about", "your next hire."]}
        copy="Tell us a little about your business and what you need. We'll come back with a clear view of how a managed team could work for you."
      />
      <section className="py-14 sm:py-16" data-testid="contact-section">
        <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
          <Reveal className="lg:col-span-7">
            <div className="rounded-2xl border border-white/10 bg-ink-2 p-8 sm:p-10">
              <ContactForm />
            </div>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="space-y-5">
              <div className="rounded-2xl border border-white/10 bg-ink-2 p-7">
                <Mail className="h-5 w-5 text-brand" aria-hidden="true" />
                <h2 className="mt-4 font-display text-lg font-semibold text-white">Email us directly</h2>
                <a
                  href="mailto:info@synergyos.com.au"
                  data-testid="contact-email-link"
                  className="mt-2 block text-sm text-brand transition-colors hover:text-brand-deep"
                >
                  info@synergyos.com.au
                </a>
              </div>
              <div className="rounded-2xl border border-white/10 bg-ink-2 p-7">
                <Clock className="h-5 w-5 text-brand" aria-hidden="true" />
                <h2 className="mt-4 font-display text-lg font-semibold text-white">Response time</h2>
                <p className="mt-2 text-sm leading-relaxed text-mist">
                  We typically respond to enquiries within one business day.
                </p>
              </div>
              <div className="rounded-2xl border border-white/10 bg-ink-2 p-7">
                <Globe className="h-5 w-5 text-brand" aria-hidden="true" />
                <h2 className="mt-4 font-display text-lg font-semibold text-white">How we work</h2>
                <p className="mt-2 text-sm leading-relaxed text-mist">
                  Synergy Outsourcing is an Australian company working with businesses across Australia, the US and
                  Canada. Delivery is structured around Australian hours or the hours that suit your team.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
